<div class="relative">
  <div
    [ngClass]="'message bot'"
    [ngStyle]="getMessageStyles()"
    (mouseover)="isHovered = true"
    (mouseout)="isHovered = false"
    [innerHTML]="messageText"
  ></div>
  <div class="display-flex flex-space-between" style="width: 94%">
    <app-message-timestamp
      *ngIf="input.created_at && input.created_at > 0"
      [createdAt]="input.created_at"
    >
    </app-message-timestamp>
    <span
      class="unread"
      *ngIf="!isRead"
      [ngStyle]="{
                'color': configs?.colors?.user_message_background,
              }"
      >{{ messageUnreadText }}</span
    >
  </div>
</div>
